//Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	

import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, Box, Tooltip, Skeleton } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import EditIcon from '@mui/icons-material/Edit';
import LockResetIcon from '@mui/icons-material/LockReset';
import MergeIcon from '@mui/icons-material/Merge';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import ParticipantEdit from './ParticipantEdit';
import ParticipantAssessmentContainer from './ParticipantAssessments';
import ParticipantDisplay from './ParticipantDisplay';
import { fetchParticipantDemographics } from '../../../reducers/admincenter_participantdemographics';
import { fetchParticipantAddresss } from '../../../reducers/admincenter_participantaddress';
import { fetchParticipantPhones } from '../../../reducers/admincenter_participantphone';
import { fetchParticipantMiscs } from '../../../reducers/admincenter_participantmisc';
import ParticipantInvite from './ParticipantInvite';
import ParticipantResetPassword from './ParticipantPasswordReset';
import ParticipantDeactivate from './ParticipantDeactivate';
import ParticipantMove from './ParticipantMove';
import ParticipantMerge from './ParticipantMerge';
import ParticipantBiometrics from './ParticipantBiometrics';
import { clientlogoClear } from '../../../reducers/reference_clientlogo';
import { navmenuClear } from '../../../reducers/reference_navmenu';
import { userLoginBehalfOf } from '../../../reducers/auth';
import { selectAdminParticipantById } from '../../../reducers/admincenter_participants';
// WsWebServicePlatform/help

// Participant/Phone/Types/Get/{AuthToken}/	

// Participant/Phone/Delete/{AuthToken}/{ParticipantPhoneGuid}/	



// Participant/Address/Delete/{AuthToken}/{ParticipantAddressGuid}/		
// Participant/Address/Types/Get/{AuthToken}/	


// Participant/Misc/Update/{AuthToken}/{ParticipantMiscGuid}/{ParticipantMiscTypeGuid}/{Priority}/{MiscData}/	
// Participant/Miscs/Get/{AuthToken}/{ParticipantGuid}/	
// Participant/Misc/Delete/{AuthToken}/{ParticipantMiscGuid}/	
// Participant/Misc/Create/{AuthToken}/{ParticipantGuid}/{ParticipantMiscTypeGuid}/{Priority}/{MiscData}/

// Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	
// Participant/Get/{AuthToken}/{ParticipantGuid}/
// Group/Participant/Create     POST BODY: has userName	

// Participant/Merge/{AuthToken}/{SourceParticipantGuid}/{TargetParticipantGuid}/	
// Group/Participant/Move/{AuthToken}/{ParticipantGuid}/{ToGroupGuid}/	

const ParticipantMainDialog = (props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const ParticipantGuid = props.Participant.ParticipantGuid
    const Participant = useSelector(state => selectAdminParticipantById(state, ParticipantGuid))
    const aryPreviousAssessments = [] //convert to state / api

    const [isEditMode, setIsEditMode] = useState(false)
    const [isInviteMode, setIsInviteMode] = useState(false)
    const [isPasswordMode, setIsPasswordMode] = useState(false)
    const [isDeactivate, setIsDeactivate] = useState(false)
    const [isMoveMode, setIsMoveMode] = useState(false)
    const [isMergeMode, setIsMergeMode] = useState(false)
    const [isBiometricMode, setIsBiometricMode] = useState(false)

    const { user: currentUser, behalfOf: behalfOfUser } = useSelector((state) => state.auth);
    const participantdemographicStatus = useSelector(state => state.participantdemographics.status)
    const participantaddressStatus = useSelector(state => state.participantaddresss.status)
    const participantphoneStatus = useSelector(state => state.participantphones.status)
    const participantmiscStatus = useSelector(state => state.participantmiscs.status)
    const behalfStatus = useSelector(state => state.auth.statusBehalf)


    const loadingArray = [
        participantdemographicStatus === 'success' ? false : true
        , participantaddressStatus === 'success' ? false : true
        , participantphoneStatus === 'success' ? false : true
        , participantmiscStatus === 'success' ? false : true
    ]

    const allLoaded = loadingArray.indexOf(true) === -1

    const handleToggleEditModeOn = () => {
        setIsEditMode(true)
    }

    const handleToggleInviteModeOn = () => {
        setIsInviteMode(true)
    }

    const handleTogglePasswordModeOn = () => {
        setIsPasswordMode(true)
    }
    const handleLoginAs = () => {
        dispatch(userLoginBehalfOf({ AuthToken: currentUser.AuthToken, ParticipantGuid: Participant.ParticipantGuid, GroupGuid: Participant.GroupGuid }))

    }
    useEffect(() => {
        if (behalfStatus === 'success') {
            // clear some view instances
            dispatch(clientlogoClear())
            dispatch(navmenuClear())
            props.closeButton()
            navigate('/home')
        }

    }, [behalfStatus, dispatch])

    const handleToggleDeactivateModeOn = () => {
        setIsDeactivate(true)
    }

    const handleToggleMoveModeOn = () => {
        setIsMoveMode(true)
    }

    const handleToggleMergeModeOn = () => {
        setIsMergeMode(true)
    }

    const handleTogglebiometricModeOn = () => {
        setIsBiometricMode(true)
    }

    const handleCancel = (closeit) => {
        setIsEditMode(false)
        setIsInviteMode(false)
        setIsPasswordMode(false)
        setIsDeactivate(false)
        setIsMoveMode(false)
        setIsMergeMode(false)
        setIsBiometricMode(false)
        if(closeit){
            props.closeButton()
        }
    }

    useEffect(() => {
        if (participantdemographicStatus === 'idle' && Participant && Participant.ParticipantGuid) {
            dispatch(fetchParticipantDemographics({ authToken: currentUser.AuthToken, ParticipantId_Guid: Participant.ParticipantGuid }))
        }
    }, [participantdemographicStatus, Participant, isEditMode, dispatch])

    useEffect(() => {
        if (participantaddressStatus === 'idle'&& Participant && Participant.ParticipantGuid) {
            dispatch(fetchParticipantAddresss({ authToken: currentUser.AuthToken, ParticipantId_Guid: Participant.ParticipantGuid }))
        }
    }, [participantaddressStatus, Participant, isEditMode, dispatch])

    useEffect(() => {
        if (participantphoneStatus === 'idle'&& Participant && Participant.ParticipantGuid) {
            dispatch(fetchParticipantPhones({ authToken: currentUser.AuthToken, ParticipantId_Guid: Participant.ParticipantGuid }))
        }
    }, [participantphoneStatus, Participant, isEditMode, dispatch])

    useEffect(() => {
        if (participantmiscStatus === 'idle'&& Participant && Participant.ParticipantGuid) {
            dispatch(fetchParticipantMiscs({ authToken: currentUser.AuthToken, ParticipantId_Guid: Participant.ParticipantGuid }))
        }
    }, [participantmiscStatus, Participant, isEditMode, dispatch])


    const IconMenu = () => {

        return (
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                <Grid item xs={4} md={6}>
                    <Tooltip title="Send Invite">
                        <Box>
                            <Button variant="text" onClick={() => { handleToggleInviteModeOn() }}
                                disabled={!allLoaded}
                            >
                                <MailOutlineIcon fontSize="large" />
                            </Button>

                        </Box>
                    </Tooltip>
                </Grid>

                <Grid item xs={4} md={6}>
                    <Tooltip title="Edit Participant">
                        <Box >
                            <Button variant="text" onClick={() => { handleToggleEditModeOn() }}
                                disabled={!allLoaded}
                            >
                                <EditIcon fontSize="large" />
                            </Button>
                        </Box>
                    </Tooltip>
                </Grid>

                <Grid item xs={4} md={6}>
                    <Tooltip title="Reset Password">

                        <Box >
                            <Button variant="text" onClick={() => { handleTogglePasswordModeOn() }}
                                disabled={!allLoaded}
                            >
                                <LockResetIcon fontSize="large" />
                            </Button>
                        </Box>
                    </Tooltip>
                </Grid>

                <Grid item xs={4} md={6}>
                    <Tooltip title={(Participant && (Participant.Status === "0" || Participant.Status === false  )) ? "Activate Participant": "Archive Participant"}>
                        <Box>
                            <Button variant="text"
                                disabled={!allLoaded}
                                onClick={() => { handleToggleDeactivateModeOn() }}
                            >
                                {(Participant && (Participant.Status === "0" || Participant.Status === false  )) ? <PersonAddAlt1Icon fontSize="large" /> : <PersonRemoveIcon fontSize="large" />}
                            </Button>
                        </Box>
                    </Tooltip>
                </Grid>

                <Grid item xs={4} md={6}>
                    <Tooltip title="Merge Participant">
                        <Box>
                            <Button variant="text"
                                disabled={!allLoaded}
                                onClick={() => { handleToggleMergeModeOn() }}
                            >
                                <MergeIcon fontSize="large" sx={{ transform: "rotate(90deg)" }} />
                            </Button>
                        </Box>
                    </Tooltip>
                </Grid>

                <Grid item xs={4} md={6}>
                    <Tooltip title="Move Participant">
                        <Box>
                            <Button variant="text"
                                disabled={!allLoaded}
                                onClick={() => { handleToggleMoveModeOn() }}
                            >
                                <MoveDownIcon fontSize="large" />
                            </Button>
                        </Box>
                    </Tooltip>
                </Grid>

            </Grid>
        )
    }
    const LandingMode = () => {
        return (
            <Grid container direction="row" alignItems="center" justifyContent="center">
                <Grid item xs={12} md={2}>
                    <IconMenu />
                </Grid>
                <Grid item xs={12} md={10}>
                    {allLoaded ? <ParticipantDisplay Participant={Participant} /> : <Skeleton sx={{ height: "200px", width: "100%" }} animation="wave" variant="rectangular" />}
                </Grid>
            </Grid>

        )
    }


    return (

        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
            {isEditMode === false
                && isInviteMode === false
                && isPasswordMode === false
                && isDeactivate === false
                && isMoveMode === false
                && isMergeMode === false
                && isBiometricMode === false
                && (
                    <Grid item xs={12}>
                        <LandingMode />
                    </Grid>
                )}

            {isEditMode === true && (
                <Grid item xs={12}>
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                        <Grid item xs={12}>
                            {allLoaded ? (<ParticipantEdit Participant={Participant} cancelButton={() => { handleCancel() }} />) : (<Skeleton variant="rectangular" />)}
                        </Grid>

                    </Grid>
                </Grid>
            )}
            {isInviteMode === true && (
                <Grid item xs={12}>
                    {allLoaded ? <ParticipantInvite ParticipantTab={props.ParticipantTab} Participant={Participant} cancelButton={() => { handleCancel() }} /> : (<Skeleton variant="rectangular" />)}
                </Grid>
            )}
            {isPasswordMode === true && (
                <Grid item xs={12}>
                    {allLoaded ? <ParticipantResetPassword ParticipantTab={props.ParticipantTab} Participant={Participant} cancelButton={() => { handleCancel() }} /> : (<Skeleton variant="rectangular" />)}
                </Grid>
            )}

            {isDeactivate === true && (
                <Grid item xs={12}>
                    {allLoaded ? <ParticipantDeactivate ParticipantTab={props.ParticipantTab} Participant={Participant} cancelButton={() => { handleCancel() }} /> : (<Skeleton variant="rectangular" />)}
                </Grid>
            )}

            {isMergeMode === true && (
                <Grid item xs={12}>
                    {allLoaded ? <ParticipantMerge ParticipantTab={props.ParticipantTab} Participant={Participant} cancelButton={(x) => { handleCancel(x) }} /> : (<Skeleton variant="rectangular" />)}
                </Grid>
            )}

            {isMoveMode === true && (
                <Grid item xs={12}>
                    {allLoaded ? <ParticipantMove ParticipantTab={props.ParticipantTab} Participant={Participant} cancelButton={() => { handleCancel() }} /> : (<Skeleton variant="rectangular" />)}
                </Grid>
            )}
            {isBiometricMode === true && (
                <Grid item xs={12}>
                    {allLoaded ? <ParticipantBiometrics Participant={Participant} cancelButton={() => { handleCancel() }} /> : (<Skeleton variant="rectangular" />)}
                </Grid>
            )}

            {
                isEditMode === false
                && isInviteMode === false
                && isPasswordMode === false
                && isDeactivate === false
                && isMoveMode === false
                && isMergeMode === false
                && isBiometricMode === false
                && allLoaded && (
                    <Grid item xs={12}>
                        <Box justifyContent="center">

                            <Button onClick={()=>handleLoginAs()}>Login As Participant</Button>
                        </Box>
                    </Grid>
                )}

            {/* {
                isEditMode === false
                && isInviteMode === false
                && isPasswordMode === false
                && isDeactivate === false
                && isMoveMode === false
                && isMergeMode === false
                && isBiometricMode === false
                && allLoaded && (
                    <Grid item xs={12}>
                        
                        <ParticipantAssessmentContainer Participant={Participant} />
                    </Grid>
                )} */}
        </Grid>

    )

}
export default ParticipantMainDialog
